import axios from "axios";
import {useStore} from "@/store/store";

export const API_BACK =  process.env?.VUE_APP_IS_DEV === "1"  ? process.env?.VUE_APP_BACK : (window.location.origin + "/api2/")
export const API_CINEMA = process.env?.VUE_APP_IS_DEV === "1"  ? process.env?.VUE_APP_API_CINEMA : (window.location.origin+ "/api/")

export async function loginQuery(login, password) {
	const {data} = await axios.post(`${API_BACK}users/login`, {login, password})
	let store = useStore()
	store.setP('access_token', data?.access_token)
	store.setP('refresh_token', data?.refresh_token)
	axios.defaults.headers.common['Authorization'] = `Bearer ${data?.access_token}`

	updateMe(store).then(() => {}).catch(console.error)
	return data
}

export async function is_role(role, store = null) {
  if(!store) store = useStore()
  const user = store.getP('user') || {}
  // todo: validate by query

  return user.role === role
}

export async function clearUser(store) {
	store.deleteP('access_token')
	store.deleteP('refresh_token')
	store.deleteP('user')
}

export async function updateMe(store = null) {
  if(!store) store = useStore()
	const now = Date.now()
	let ret = {}
	const user = store.getP('user') || {}

	if(!user || !user?.fetched_at || (now - user?.fetched_at) > 60000*60*24*31) {
		const r = await new Back("users/me", 'get', "back").run()
    console.log("user update", user, now, r)

		if(r?.data?.login) {
			ret = {...r?.data, fetched_at: now}
			store.setP('user', ret)
		}
		else if(store.getP('access_token')) {
			await clearUser(store)
		}
	}

	return ret
}

export class Back {
	constructor(endpoint, method = "get", api_name='cinema') {
		this.store = useStore()
		this.endpoint = endpoint
		this.data = null
		this.method = method
		this.loading_key = "loading"
		this.api_url = api_name === "back" ? API_BACK : API_CINEMA
    this.last_status = null
	}

	setData(data) {
		this.data = data
		return this
	}

	setLoadingKey(loading_key) {
		this.loading_key = loading_key
		return this
	}

  run(callback = null) {
    // фиксируем начало загрузки для текущего ключа
    this.store.setLoading(this.loading_key)

    // флаги и очередь, чтобы синхронизировать параллельные запросы на время refresh
    let isRefreshing = false
    let failedQueue = []

    // создаём отдельный экземпляр axios с нужным базовым URL и заголовками
    const api = axios.create({
      baseURL: this.api_url,
      // timeout: 240 * 1000,
    })

    // утилита, пробуждающая все запросы, ожидавшие refresh токена
    const processQueue = (error, token = null) => {
      failedQueue.forEach(prom => (error ? prom.reject(error) : prom.resolve(token)))
      failedQueue = []
    }

    // request‑интерцептор: перед каждым вызовом поднимаем access_token из стора
    api.interceptors.request.use(config => {
      const token = this.store.getP('access_token')

      if (token) config.headers['Authorization'] = `Bearer ${token}`
      else delete config.headers['Authorization']

      const method = (config.method || 'get').toLowerCase()
      if (method === 'get' || method === 'head') delete config.headers['Content-Type']
      else config.headers['Content-Type'] = 'application/json'

      return config
    })

    // response‑интерцептор: обрабатываем ответы и все классы ошибок
    api.interceptors.response.use(
      response => {
        // успех: снимаем индикатор загрузки и отдаём ответ дальше
        this.store.setLoaded(this.loading_key)
        return response
      },
      async error => {
        const status = error?.response?.status
        const originalRequest = error?.config ?? {}
        this.last_status = status

        // серверные ошибки и типичные 4xx без повторной попытки
        if ([400, 404, 500, 503].includes(status)) {
          const detailMsg = error.response?.data?.detail || `Ошибка ${status}`
          this.store.addMessage(detailMsg)
          this.store.setLoaded(this.loading_key)
          // return Promise.reject(error)
          return Promise.resolve(null)
        }

        // авторизационные ошибки: пробуем refresh токена и повтор запроса
        if ([401, 403].includes(status)) {
          // если уже пытаемся обновить токен, ставим текущий запрос в очередь ожидания
          if (isRefreshing) {
            return new Promise((resolve, reject) => failedQueue.push({ resolve, reject }))
              .then(token => {
                originalRequest.headers['Authorization'] = `Bearer ${token}`
                return api(originalRequest)
              })
              .finally(() => this.store.setLoaded(this.loading_key))
          }

          // первая попытка обновления
          if (!originalRequest._retry) {
            originalRequest._retry = true
            isRefreshing = true

            try {
              const refreshToken = this.store.getP('refresh_token')
              const res = await axios.post(`${API_BACK}users/refresh`, { token: refreshToken })
              const newAccessToken = res.data?.access_token

              this.store.setP('access_token', newAccessToken)
              api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`
              processQueue(null, newAccessToken)

              originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
              return api(originalRequest)
            } catch (refreshError) {
              // refresh провалился: чистим очередь, пользователя и отправляем на /login
              processQueue(refreshError, null)

              await clearUser(this.store)
              window.location.href = '/login'
              // ? Не будем заставлять юзера перелогиниваться
              // this.store.addMessage("Ошибка авторизации или недостаточно прав")

              return Promise.reject(refreshError)
            } finally {
              isRefreshing = false
              this.store.setLoaded(this.loading_key)
            }
          }

          // повторная 401/403 после refresh: чистим пользователя и редиректим
          await clearUser(this.store)
          window.location.href = '/login'

          this.store.setLoaded(this.loading_key)
          return Promise.reject(error)
        }

        // fallback для всех остальных ошибок
        const message = error?.message || 'Неизвестная ошибка'
        this.store.addMessage(message)
        this.store.setLoaded(this.loading_key)
        return callback ? callback(error) : Promise.reject(error)
      }
    )

    // собираем аргументы запроса в зависимости от метода
    const args = {
      url: this.endpoint.startsWith(this.api_url) ? this.endpoint : `${this.api_url}${this.endpoint}`,
      method: this.method
    }

    const payload = this.data ? { ...this.data } : {}
    Object.keys(payload).forEach(key => {
      if (payload[key] === null) delete payload[key]
      if (payload[key] === 'null') payload[key] = null
    })
    args[this.method === 'get' ? 'params' : 'data'] = payload

    // инициируем запрос и при необходимости оборачиваем его в колбэк
    try {
      const promise = api.request(args)
      return callback ? promise.then(callback) : promise
    } catch (error) {
      return callback ? Promise.reject(error).then(callback) : Promise.reject(error)
    }
  }
}